const productData = {
  "categories": [
    {
      "categoryName": "All Devices",
      "categoryId": "all-devices",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_All_Devices.svg?v=1751942115",
      "subCategories": [
        {
          "categoryName": "All Devices",
          "categoryId": "all-devices",
          "products": []
        }
      ]
    },
    {
      "categoryName": "Oscilloscope Multimeter",
      "categoryId": "oscilloscope-multimeter",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1756965508_0.svg?v=1756965877",
      "subCategories": [
        {
          "categoryName": "Benchtop Oscilloscope Multimeter",
          "categoryId": "benchtop-oscilloscope-multimeter",
          "products": [
            {
              "productName": "FNIRSI® 2D15P 3-in-1 2CH 100MHz Phosphor Oscilloscope Multimeter",
              "model": "2D15P",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2D15P.jpg?v=1757994289",
              "url": "",
              "status": "",
              "manuals": [
                {
                  "name": "2D15P Manual (EN, ZH).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2D15P_Manual_ZH_EN.pdf?v=1757993250",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "2D15P Firmware V1.2.0.6.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2D15P_Firmware_V1.2.0.6.zip?v=1757993221",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Tablet Oscilloscope Multimeter",
          "categoryId": "tablet-oscilloscope-multimeter",
          "products": [
            {
              "productName": "FNIRSI® 2C53P 3in1 Tablet Oscilloscope Multimeter Function Generator",
              "model": "2C53P",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C53P.jpg?v=1740568097",
              "url": "/products/2c53p",
              "status": "",
              "manuals": [
                {
                  "name": "2C53P Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53P-_Manual.pdf?v=1715670710",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "2C53P Firmware V1.10.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53P_Firmware_V1.10.zip?v=1756973515",
                  "btnText":"Download"
                },
                {
                  "name": "2C53P Firmware V1.8.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53P_Firmware_V1.8_NEW.zip?v=1756973515",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Handheld Oscilloscope Multimeter",
          "categoryId": "handheld-oscilloscope-multimeter",
          "products": [
            {
              "productName": "FNIRSI® 2C53T Handheld 3in1 Oscilloscope Multimeter Signal Generator",
              "model": "2C53T",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C53T.jpg?v=1740568119",
              "url": "/products/2c53t",
              "status": "",
              "manuals": [
                {
                  "name": "2C53T Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53T_User_Manual_4_Languages.pdf?v=1738752548",
                  "btnText":"Download"
                },
                {
                  "name": "2C53T Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53T.pdf?v=1738752814",
                  "btnText":"Download"
                },
                {
                  "name": "2C53T Manual (ES).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Manual_espanol_FNIRSI_2C53T.pdf?v=1738752814",
                  "btnText":"Download"
                },
                {
                  "name": "2C53T Manual (FR).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C53T_User_Manual_FR_V1.5.pdf?v=1741334131",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "2C53T Firmware V1.0.7 (latest).bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_2C53T_V1.0.7_241205.bin?v=1744111377",
                  "btnText":"Download"
                },
                {
                  "name": "2C53T Firmware V1.0.3 (Initial).bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_2C53T_V1.0.3_240814.bin?v=1744111530",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DST-210 Handheld 3-IN-1 Multimeter Oscilloscope Signal Generator",
              "model": "DST-210",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DST-210.jpg?v=1756983987",
              "url": "/products/dst-210-dst-201?variant=46256156770522",
              "status": "",
              "manuals": [
                {
                  "name": "DST-210 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DST-210_Manual_ZH_EN.pdf?v=1741088552",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DST-201 Handheld 3-IN-1 Multimeter Oscilloscope Signal Generator",
              "model": "DST-201",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DST-201.jpg?v=1756983987",
              "url": "/products/dst-210-dst-201?variant=46256156803290",
              "status": "",
              "manuals": [
                {
                  "name": "DST-201 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DST-201_Manual_ZH_EN.pdf?v=1741088552",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DST-201 Firmware V0.0.4.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DST-201_Firmware_V0.0.4.zip?v=1756983196",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® 2C23T Handheld 3in1 Oscilloscope Digital Multimeter Signal Generator",
              "model": "2C23T",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C23T.jpg?v=1740568138",
              "url": "/products/2c23t",
              "status": "",
              "manuals": [
                {
                  "name": "2C23T Manual (ZH, EN, DE, RU, PT, ES).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C23T-_Manual.pdf?v=1715670687",
                  "btnText":"Download"
                },
                {
                  "name": "2C23T Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/2C23T_JP.pdf?v=1738751598",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Digital Oscilloscope",
      "categoryId": "digital-oscilloscope",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Digital_Oscilloscope.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Benchtop Oscilloscope",
          "categoryId": "benchtop-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014D",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "url": "/products/1014d",
              "status": "",
              "manuals": [
                {
                  "name": "1014D Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1014D-Manual.pdf?v=1718359424",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "1014D Firmware V3.0.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1014D_Firmware_V3.0.zip?v=1733724382",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Tablet Oscilloscope",
          "categoryId": "tablet-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 1013D Dual Channel Touchable Panel Oscilloscope",
              "model": "1013D",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1013D.jpg?v=1740568051",
              "url": "/products/1013d",
              "status": "",
              "manuals": [
                {
                  "name": "1013D Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1013D-_Manual.pdf?v=1715670613",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "1013D Firmware.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1013D_Firmware.zip?v=1738750719",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DPOS350P Oscilloscope Signal Generator Spectrum Analyzer Frequency Response Analyzer",
              "model": "DPOS350P",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P.jpg?v=1741079875",
              "url": "/products/dpos350p",
              "status": "",
              "manuals": [
                {
                  "name": "DPOS350P Manual (EN, ES, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOS350P_Manual_EN_ES_PT_New.pdf?v=1756283594",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DPOS350P Firmware.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOS350P_Firmware_file.zip?v=1754118464",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": [
                {
                  "name": "Firmware Update.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/d055d454224d4397a1e98c66608c3be9.mp4",
                  "btnText":"Play Video"
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Handheld Oscilloscope",
          "categoryId": "handheld-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® DPOX180H 2in1 Digial Phosphor Oscilloscope Signal Generator",
              "model": "DPOX180H",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOX180H.jpg?v=1740568075",
              "url": "/products/dpox180h",
              "status": "",
              "manuals": [
                {
                  "name": "DPOX180H Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOX180H_Manual.pdf?v=1718351873",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DPOX180H Firmware V40.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOX180H-V40.zip?v=1718352527",
                  "btnText":"Download"
                },
                {
                  "name": "DPOX180H Firmware V30.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOX180H-V30.zip?v=1744795578",
                  "btnText":"Download"
                },
                {
                  "name": "DPOX180H Firmware V20.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPOX180H-V20.zip?v=1744795578",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DSO-TC4 3in1 Digital Oscilloscope Transistor Tester Signal Generator",
              "model": "DSO-TC4",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DSO-TC4.jpg?v=1740568160",
              "url": "/products/dso-tc4",
              "status": "",
              "manuals": [
                {
                  "name": "DSO-TC4 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC4_Manuals-V1.6-2025.03.10.pdf?v=1741599656",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-TC4 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC4.pdf?v=1742461916",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DSO-TC4 Firmware V0.0.3 (+V1.0.9).zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC4_Firmware_v0.0.3_v1.0.9_new.zip?v=1748313493",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-TC4 Firmware V0.0.2 (+V1.0.7).zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC4_Firmware_v1.0.7.zip?v=1742453820",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DSO-510 2in1 Mini Handheld Digital Oscilloscope Signal Generator",
              "model": "DSO-510",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DSO-510.jpg?v=1740568182",
              "url": "/products/dso-510",
              "status": "",
              "manuals": [
                {
                  "name": "DSO-510 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-510_Manual.pdf?v=1724116763",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-510 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-510.pdf?v=1738824127",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DSO-510 Firmware V1.0.3.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO-510_V1.0.3_241009.bin?v=1756205288",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-510 Firmware V1.0.1.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO-510_V1.0.1_240808.bin?v=1756205288",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-510 Firmware V1.0.0.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO-510_V1.0.0_240709.bin?v=1756205288",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DSO-TC3 3-IN-1 Handheld Digital Oscilloscope Signal Generator Transistor Tester",
              "model": "DSO-TC3",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DSO-TC3.jpg?v=1740568209",
              "url": "/products/dso-tc3",
              "status": "",
              "manuals": [
                {
                  "name": "DSO-TC3 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC3_Manual-V1.9-2023.03.29.pdf?v=1738755671",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-TC3 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-TC3.pdf?v=1738755183",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DSO-TC3 Firmware V0.3.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO_TC3_Firmware_V0.3.zip?v=1756205795",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-TC3 Firmware V0.22.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO_TC3_Firmware_V0.22.zip?v=1756205639",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "DSO-TC3 Firmware Update Tool.exe",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Firmware_Update_Tool_v0.1.exe?v=1756205685",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": [
                {
                  "name": "Upgrade Video.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/349e93a3dceb45e2abcf15d28074adc5.mp4",
                  "btnText":"Play Video"
                }
              ]
            },
            {
              "productName": "FNIRSI® DS215H 2in1 Dual-Channel Digital Oscilloscope Singal Generator",
              "model": "DS215H",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DS215H.jpg?v=1740811734",
              "url": "/products/ds215h",
              "status": "",
              "manuals": [
                {
                  "name": "DS215H Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DS215H_Manual_ZH_EN-60p-V1.1-2025.01.07.pdf?v=1740811725",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DSO-153 2-IN-1 Mini Digital Oscilloscope Waveform Generator",
              "model": "DSO-153",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DSO-153.jpg?v=1740568231",
              "url": "/products/dso-153",
              "status": "",
              "manuals": [
                {
                  "name": "DSO-153 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-153-_Manual.pdf?v=1715670948",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DSO-153 Firmware V1.1.8.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO-153_V1.1.8_240730.bin?v=1732068032",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.1.7.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO-153_V1.1.7_240513.bin?v=1756205928",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.6.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO153_V1.6_20240427.bin?v=1756205928",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO153_V1.5_20240301.bin?v=1756205928",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.4.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO153_V1.4_20240218.bin?v=1756205928",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.3.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO153_V1.3_20240202.bin?v=1756205928",
                  "btnText":"Download"
                },
                {
                  "name": "DSO-153 Firmware V1.2.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DSO153_V1.2_20240131.bin?v=1756205928",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DSO-152 Mini Pocket Handheld Digital Oscilloscope",
              "model": "DSO-152",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DSO-152.jpg?v=1740568253",
              "url": "/products/dso-152",
              "status": "",
              "manuals": [
                {
                  "name": "DSO-152 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO-152-_Manual.pdf?v=1715670917",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DSO-152 Firmware V0.1 (Initial).bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DSO152_APP_V0.1.bin?v=1745739100",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® 1C15 Handheld Mini Digital Oscilloscope",
              "model": "1C15",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1C15.jpg?v=1740568272",
              "url": "/products/1c15",
              "status": "",
              "manuals": [
                {
                  "name": "1C15 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/1C15-_Manual.pdf?v=1715670659",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® 5012H Digital Handheld Pocket Oscilloscope",
              "model": "5012H",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_5012H.jpg?v=1740568291",
              "url": "/products/5012h",
              "status": "",
              "manuals": [
                {
                  "name": "5012H Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/5012H-_Manual.pdf?v=1715670745",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® 138 PRO Handheld Oscilloscope",
              "model": "FNIRSI-138 PRO",
              "status": "",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_138_PRO.jpg?v=1740810449",
              "url": "",
              "manuals": [
                {
                  "name": "FNIRSI-138 PRO Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi_138_pro_manual.pdf?v=1734746829",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]  
    },
    {
      "categoryName": "Electrical Testing",
      "categoryId": "electrical-testing",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Electrical_Testings.svg?v=1751713381",
      "subCategories": [
        {
          "categoryName": "Digital Multimeter",
          "categoryId": "digital-multimeter",
          "products": [
            {
              "productName": "FNIRSI® DMT-99 Intelligent Color Screen Digital Multi Meter",
              "model": "DMT-99",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DMT-99.jpg?v=1740568366",
              "url": "/products/dmt-99",
              "status": "",
              "manuals": [
                {
                  "name": "DMT-99 Manual (ZH, EN, RU, DE, PT, ES).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMT-99_Manual_6_languages_ZH_EN_RU_DE_PT_ES_V2.7.pdf?v=1728359651",
                  "btnText":"Download"
                },
                {
                  "name": "DMT-99 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMT-99.pdf?v=1738757804",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DMT-99 Firmware V2.4.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMT-99_V2.4_20240306.BIN?v=1756206088",
                  "btnText":"Download"
                },
                {
                  "name": "DMT-99 Firmware V2.2.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DMT-99_V2.2.BIN?v=1756206088",
                  "btnText":"Download"
                },
                {
                  "name": "DMT-99 Firmware V2.1.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMT-99_firmware_V2.1.zip?v=1756206088",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® S1 Large Screen Digital Display Smart Multimeter",
              "model": "S1",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_S1.jpg?v=1740568427",
              "url": "/products/s1",
              "status": "",
              "manuals": [
                {
                  "name": "S1 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/S1_User_Manual.pdf?v=1738758391",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® MT-40 Smart Digital Multimeter",
              "model": "MT-40",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_MT-40.jpg?v=1740568410",
              "url": "/products/mt-40",
              "status": "Discontinued",
              "manuals": [
                {
                  "name": "MT-40 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/MT-40_User_Manual.pdf?v=1731555299",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Clamp Multimeter",
          "categoryId": "clamp-multimeter",
          "products": [
            {
              "productName": "FNIRSI® DMC-100 DC AC Current Voltage Clamp Meter Digital Multimeter",
              "model": "DMC-100",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DMC-100.jpg?v=1740568343",
              "url": "/products/dmc-100",
              "status": "",
              "manuals": [
                {
                  "name": "DMC-100 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMC-100_User_Guide.pdf?v=1733363686",
                  "btnText":"Download"
                },
                {
                  "name": "DMC-100 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DMC-100.pdf?v=1738757542",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                // {
                //   "name": "DMC-100 Firmware v1.4.bin (latest)",
                //   "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DMC-100_V1.4_250524.bin?v=1748313820",
                //   "btnText":"Download"
                // },
                {
                  "name": "DMC-100 Firmware v1.2.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DMC-100_V1.2_241107.bin?v=1756272863",
                  "btnText":"Download"
                },
                {
                  "name": "DMC-100 Firmware v1.1.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DMC-100_V1.1_241031.bin?v=1756272863",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® MC-40 Clamp Meter Digital Multimeter",
              "model": "MC-40",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_MC-40.jpg?v=1740568388",
              "url": "/products/mc-40",
              "status": "Discontinued",
              "manuals": [
                {
                  "name": "MC-40 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/MC-40_User_Manual.pdf?v=1731555304",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Multifunction Calibrator",
          "categoryId": "multifunction-calibrator",
          "products": [
            {
              "productName": "FNIRSI® SG-004A Multi-functional Signal Generator",
              "model": "SG-004A",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SG-004A.jpg?v=1740568685",
              "url": "/products/sg-004a",
              "status": "",
              "manuals": [
                {
                  "name": "SG-004A Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SG-004A-_Manual.pdf?v=1715671341",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "SG-004A Firmware V3.0.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SG-004A_V3.0_20230825.bin?v=1756377442",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® SG-003A Signal Generator",
              "model": "SG-003A",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SG-003A.jpg?v=1740568690",
              "url": "/products/sg-003",
              "status": "",
              "manuals": [
                {
                  "name": "SG-003A Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SG-003A-_Manual.pdf?v=1715671314",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "SG-003A Firmware V4.3.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SG-003A_V4.3.zip?v=1718353300",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® SG-002 Signal Generator",
              "model": "SG-002",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SG-002.jpg?v=1740809751",
              "url": "",
              "status": "",
              "manuals": [
                {
                  "name": "SG-002 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SG-002_Manuals_EN.pdf?v=1740809045",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Signal Analysis",
      "categoryId": "signal-analysis",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Signal_Analysis.svg?v=1750762076",
      "subCategories": [
        {
          "categoryName": "USB Tester",
          "categoryId": "usb-tester",
          "products": [
            {
              "productName": "FNIRSI® FNB58 USB Fast Charge Tester",
              "model": "FNB58",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FNB58.jpg?v=1740568557",
              "url": "/products/fnb58",
              "status": "",
              "manuals": [
                {
                  "name": "FNB58 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58-_Manual.pdf?v=1715651127",
                  "btnText":"Download"
                },
                {
                  "name": "FNB58 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58_Manual-Japanese.pdf?v=1730094767",
                  "btnText":"Download"
                },
                {
                  "name": "FNB58 Manual (RU).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FN58_User_Manual_rus.pdf?v=1738829839",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "FNB58 Firmware V0.68.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58_V0.68.zip?v=1719813986",
                  "btnText":"Download"
                },
                {
                  "name": "FNB58 Firmware V0.67.rar",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58_V0.67.rar?v=1756273009",
                  "btnText":"Download"
                },
                {
                  "name": "FNB58 Firmware V0.63.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58_V0.63.zip?v=1756273009",
                  "btnText":"Download"
                },
                {
                  "name": "FNB58 Firmware V0.50.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB58_V0.50.zip?v=1756273009",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "UsbMeter Software.zip",
                  "url": "https://drive.google.com/file/d/1IwgpijYc0RhVRmYVgj7oPJg6GsckbJTq/view?usp=sharing",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® FNB48P USB Fast Charge Tester",
              "model": "FNB48P",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FNB48P.jpg?v=1740568578",
              "url": "/products/fnb48p",
              "status": "",
              "manuals": [
                {
                  "name": "FNB48P Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB48P-_Manual.pdf?v=1715671084",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "FNB48P/S Firmware V1.1.0.ufn (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb48sV1.10.ufn?v=1756273351",
                  "btnText":"Download"
                },
                {
                  "name": "FNB48P/S Firmware V1.0.ufn",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb48s_V1.0.ufn?v=1756273351",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "UsbMeter Software.zip",
                  "url": "https://drive.google.com/file/d/1IwgpijYc0RhVRmYVgj7oPJg6GsckbJTq/view?usp=sharing",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® FNB48S USB Tester",
              "model": "FNB48S",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FNB48S.jpg?v=1740567856",
              "url": "/products/fnb48s",
              "status": "Discontinued",
              "manuals": [
                {
                  "name": "FNB48S Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB48S-Manual.pdf?v=1718335795",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "FNB48P/S Firmware V1.1.0.ufn (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb48sV1.10.ufn?v=1756273351",
                  "btnText":"Download"
                },
                {
                  "name": "FNB48P/S Firmware V1.0.ufn",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb48s_V1.0.ufn?v=1756273351",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "UsbMeter Software.zip",
                  "url": "https://drive.google.com/file/d/1IwgpijYc0RhVRmYVgj7oPJg6GsckbJTq/view?usp=sharing",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® FNAC-28 2-IN-1 Type-C USB Tester Digital Voltmeter Ammeter Power Bank Charger Measure",
              "model": "FNAC-28",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FNAC-28.jpg?v=1740568609",
              "url": "/products/fnac-28",
              "status": "",
              "manuals": [
                {
                  "name": "FNAC-28 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNAC-28_User_Manual_EN_ZH_V-1.0-06.03.pdf?v=1729670846",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® C1 Type-C PD Trigger USB-C Voltmeter Ammeter Fast Charging Protocol Tester",
              "model": "C1",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_C1_1.jpg?v=1756352677",
              "url": "/products/c1",
              "status": "Discontinued",
              "manuals": [
                {
                  "name": "C1 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/C1_Manual.pdf?v=1719283204",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® FNB38 USB Tester",
              "model": "FNB38",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FNB38.jpg?v=1740567357",
              "url": "",
              "status": "Discontinued",
              "manuals": [
                {
                  "name": "FNB38 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB38_Manual.pdf?v=1718592503",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "FNB38 Firmware v2.0.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNB38_Firmware_v2.0.zip?v=1740563802",
                  "btnText":"Download"
                },
                {
                  "name": "FNB38 Firmware v1.6.ufn",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb38V1.60.ufn?v=1756273433",
                  "btnText":"Download"
                },
                {
                  "name": "FNB38 Firmware v1.4.ufn",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/Fnb38v1.40.ufn?v=1756273433",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "UpdateTool v1.2.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/UpdateToolv1.2.zip?v=1740563802",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": []
            }
          ]
        }
      ]  
    },
    {
      "categoryName": "Soldering & Assembly",
      "categoryId": "soldering-assembly",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Soldering_Assembly.svg?v=1750762076",
      "subCategories": [
        {
          "categoryName": "Hot Air Gun",
          "categoryId": "hot-air-gun",
          "products":[
            {
              "productName": "FNIRSI® SAG-55 Intelligent 550W Hot Air Gun",
              "model": "SAG-55",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SAG-55.jpg?v=1748281787",
              "url": "/products/sag-55",
              "status": "",
              "manuals": [
                {
                  "name": "SAG-55 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SAG-55_User_Manual_EN_ZH.pdf?v=1748280739",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Soldering Iron",
          "categoryId": "soldering-iron",
          "products":[
            {
              "productName": "FNIRSI® HS-02 Intelligent Soldering Iron",
              "model": "HS-02",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_HS-02_NEW.jpg?v=1747382887",
              "url": "/products/hs-02",
              "status": "",
              "manuals": [
                {
                  "name": "HS-02 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS-02_User_Guide_New.pdf?v=1741596847",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02 Manual (JP).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS-02.pdf?v=1738826097",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "HS-02A Firmware V1.8.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02A_V1.8_250217.bin?v=1756273491",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02B Firmware V1.8.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02B_V1.8_250218.bin?v=1756273497",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02A Firmware V1.7.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02A_V1.7_241030.bin?v=1730356567",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02B Firmware V1.7.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02B_V1.7_241030.bin?v=1730356567",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02A Firmware V1.6.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02A_V1.6_20240408.bin?v=1756273491",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02B Firmware V1.6.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02B_V1.6_20240408.bin?v=1756273497",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02A Firmware V1.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02A_V1.5_20240321.bin?v=1756273491",
                  "btnText":"Download"
                },
                {
                  "name": "HS-02B Firmware V1.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_HS_02B_V1.5_20240321.bin?v=1756273497",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® HS-01 Intelligent Soldering Iron",
              "model": "HS-01",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_HS-01.jpg?v=1740568515",
              "url": "/products/hs-01",
              "status": "",
              "manuals": [
                {
                  "name": "HS-01 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS-01-_Manual.pdf?v=1715671215",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "HS-01 Firmware V0.3.s19 (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS-01_firmware_V0.3.s19.zip?v=1715412999",
                  "btnText":"Download"
                },
                {
                  "name": "HS-01 Firmware V0.2.s19",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS01_V0.2.s19?v=1756273632",
                  "btnText":"Download"
                },
                {
                  "name": "HS-01 Firmware V0.1.s19",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS01_V0.1.s19?v=1756273632",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "HS-01 Firmware Update Tool.exe",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HS-01_Firmware_Update_Tool.exe?v=1756273704",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": [
                {
                  "name": "Upgrade Video.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/cd067e4eea12468f9eaf1665841400c0.mp4",
                  "btnText":"Play Video"
                }
              ]
            },
          ]
        },
        {
          "categoryName": "Soldering Station",
          "categoryId": "soldering-station",
          "products":[
            {
              "productName": "FNIRSI® DWS-200 200W Power Repaid Heating Soldering Iron Station Kit",
              "model": "DWS-200",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DWS-200.jpg?v=1740568493",
              "url": "/products/dws-200",
              "status": "",
              "manuals": [
                {
                  "name": "DWS-200 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DWS-200_User_Manual.pdf?v=1738829574",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "DWS-200 Firmware V1.3.rar (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DWS-200-V1.3.rar?v=1756273854",
                  "btnText":"Download"
                },
                {
                  "name": "DWS-200 Firmware V1.2.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DWS_200_V1.2_20240426.bin?v=1756273854",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },   
        {
          "categoryName": "Spot Welder",
          "categoryId": "spot-welder",
          "products":[
            {
              "productName": "FNIRSI® SWM-10 Portable Intelligent Color Screen Spot Welding Machine",
              "model": "SWM-10",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SWM-10.jpg?v=1740568471",
              "url": "/products/swm-10",
              "status": "",
              "manuals": [
                {
                  "name": "SWM-10 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SWM-10-_Manual.pdf?v=1715671453",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "SWM-10 Firmware V1.4.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_SWM-10_V1.4.bin?v=1756274014",
                  "btnText":"Download"
                },
                {
                  "name": "SWM-10 Firmware V1.2.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SWM-10-APP-V1.2.bin?v=1756274014",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": [
                {
                  "name": "Upgrade Video.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/c82b7be561bc478b9af6bc4330d743ec.mp4",
                  "btnText":"Play Video"
                },
                {
                  "name": "Change language & check FW version.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/61cb0afda4d14f70a3782f80df59954c.mp4",
                  "btnText":"Play Video"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Power & Performance",
      "categoryId": "power-performance",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Power_Performance.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "DC Power Supply",
          "categoryId": "dc-power-supply",
          "products": [
            {
              "productName": "FNIRSI® IPS3608 AC-DC Intelligent Digital Control Power Supply",
              "model": "IPS3608",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_IPS3608.jpg?v=1747985455",
              "url": "/products/ips3608",
              "status": "",
              "manuals": [
                {
                  "name": "IPS3608 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/IPS3608_User_Manual_EN_ZH.pdf?v=1747733683",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "IPS3608 Firmware V1.3.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/IPS3608_V1.3.zip?v=1754118868",
                  "btnText":"Download"
                },
                {
                  "name": "IPS3608 Firmware V1.2.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/IPS3608_V1.2.zip?v=1754118868",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® DPS-150 Mini DC Adjustable CNC Programmable Regulated Switching Power Supply",
              "model": "DPS-150",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPS-150.jpg?v=1741255856",
              "url": "/products/dps-150",
              "status": "",
              "manuals": [
                {
                  "name": "DPS-150 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/DPS-150_Manual.pdf?v=1725501842",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                // {
                //   "name": "DPS-150 Firmware V0.0.1 (Initial).bin",
                //   "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_DPS-150_V0.0.1_241025.bin?v=1756274082",
                //   "btnText":"Download"
                // }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Internal Resistance Tester",
          "categoryId": "internal-resistance-tester",
          "products": [
            {
              "productName": "FNIRSI® HRM-10 Battery Voltage Internal Resistance Tester",
              "model": "HRM-10",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_HRM-10.jpg?v=1740568935",
              "url": "/products/hrm-10",
              "status": "",
              "manuals": [
                {
                  "name": "HRM-10 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HRM-10_User_Manual-20241211.pdf?v=1733978035",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "HRM-10 Firmware V0.3.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HRM-10-V0.3.zip?v=1725263945",
                  "btnText":"Download"
                },
                {
                  "name": "HRM-10 Firmware V0.2.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/HRM-10_V0.2-20240430.bin?v=1756274181",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Environmental & Home",
      "categoryId": "environmental-home",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Environmental_Home.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Nuclear Radiation Detector",
          "categoryId": "nuclear-nadiation-detector",
          "products": [
            {
              "productName": "FNIRSI® GC-03 Multifunctional Radiation Detector",
              "model": "GC-03",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GC-03.jpg?v=1749113247",
              "url": "/products/gc-03",
              "status": "",
              "manuals": [
                {
                  "name": "GC-03 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-03_User_Manual_EN_ZH.pdf?v=1749112980",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "GC-03 Firmware v1.0.4.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC_03_V1.0.4_firmware.zip?v=1755834664",
                  "btnText":"Download"
                },
                {
                  "name": "GC-03 Firmware v1.0.3.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC_03_V1.0.3_firmware.zip?v=1752896236",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® GC-02 Geiger Counter Nuclear Radiation Detector",
              "model": "GC-02",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GC-02.jpg?v=1740568758",
              "url": "/products/gc-02",
              "status": "",
              "manuals": [
                {
                  "name": "GC-02 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-02_Manual.pdf?v=1724726427",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® GC-01 Nuclear Radiation Detector",
              "model": "GC-01",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GC-01.jpg?v=1740568754",
              "url": "/products/gc-01",
              "status": "",
              "manuals": [
                {
                  "name": "GC-01 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-01-_Manual.pdf?v=1715671185",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "GC-01 Firmware v1.6.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-01_V1.6.bin?v=1756274402",
                  "btnText":"Download"
                },
                {
                  "name": "GC-01 Firmware v1.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-01_V1.5.bin?v=1756274402",
                  "btnText":"Download"
                },
                {
                  "name": "GC-01 Firmware v0.3.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GC-01_V0.3.bin?v=1756274402",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": [
                {
                  "name": "Upgrade Video.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/c0eb68e5ca134145b0162dc133dfd896.mp4",
                  "btnText":"Play Video"
                }
              ]
            }
          ]
        },
        {
          "categoryName": "EMF Detector",
          "categoryId": "emf-detector",
          "products": [
            {
              "productName": "FNIRSI® ERD-10 4-IN-1 Electromagnetic Radiation Detector",
              "model": "ERD-10",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_ERD-10.jpg?v=1747985105",
              "url": "/products/erd-10",
              "status": "",
              "manuals": [
                {
                  "name": "ERD-10 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/ERD-10_User_Manual_EN_ZH.pdf?v=1747730537",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Formaldehyde Detector",
          "categoryId": "formaldehyde-detector",
          "products": [
            {
              "productName": "FNIRSI® SFD-02 4-IN-1 Indoor Air Quality Monitor Touchscreen Formaldehyde Detector HCHO TVOC Temperature Tester",
              "model": "SFD-02",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_SFD-02.jpg?v=1745991272",
              "url": "/products/sfd-02",
              "status": "",
              "manuals": [
                {
                  "name": "SFD-02 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/SFD-02_User_Manual.pdf?v=1745479395",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Combustible Gas Detector",
          "categoryId": "combustible-gas-detector",
          "products": [
            {
              "productName": "FNIRSI® GD-02 Color Screen Combustible Gas Detector",
              "model": "GD-02",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GD-02.jpg?v=1756791738",
              "url": "/products/gd-02",
              "status": "",
              "manuals": [
                {
                  "name": "GD-02 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/GD-02_User_Manual.pdf?v=1756784200",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Wall Detector",
          "categoryId": "wall-detector",
          "products": [
            {
              "productName": "FNIRSI® WD-02 Wall Detector Scanner",
              "model": "WD-02",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_WD-02.jpg?v=1740568829",
              "url": "/products/wd02",
              "status": "",
              "manuals": [
                {
                  "name": "WD-02 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/WD-02-_Manual.pdf?v=1715671489",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® WD-01 Wall Detector Scanner",
              "model": "WD-01",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_WD-01.jpg?v=1740568832",
              "url": "/products/wd01",
              "status": "",
              "manuals": [
                {
                  "name": "WD-01 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/WD-01-_Manual.pdf?v=1715671480",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Wood Moisture Meter",
          "categoryId": "wood-moisture-meter",
          "products": [
            {
              "productName": "FNIRSI® WMT-10 Non-contact Inductive Wood & Wall Moisture Meter Hygrometer",
              "model": "WMT-10",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_WMT-10.jpg?v=1740568784",
              "url": "/products/wmt-10",
              "status": "",
              "manuals": [
                {
                  "name": "WMT-10 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/WMT-10__Manual_CN_EN_-V1.0.pdf?v=1731319955",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Laser Rangefinder",
          "categoryId": "laser-rangefinder",
          "products": [
            {
              "productName": "FNIRSI® IR40 Smart Laser Rangefinder",
              "model": "IR40",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_IR40.jpg?v=1740568883",
              "url": "/products/ir40",
              "status": "",
              "manuals": [
                {
                  "name": "IR40 Manual (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/IR40-_Manual.pdf?v=1715671956",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Sound Level Meter",
          "categoryId": "sound-level-meter",
          "products": [
            {
              "productName": "FNIRSI® FDM01 High-precision Digital Noise Decibel Meter",
              "model": "FDM01",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FDM01.jpg?v=1740568854",
              "url": "/products/fdm01",
              "status": "",
              "manuals": [
                {
                  "name": "FDM01 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FDM01-_Manual.pdf?v=1715671024",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Component Testing",
      "categoryId": "component-testing",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Component_Testings.svg?v=1751713367",
      "subCategories": [
        {
          "categoryName": "Transistor Tester",
          "categoryId": "transistor-tester",
          "products": [
            {
              "productName": "FNIRSI® LCR-P1 Multifunction Transistor Capacitor Tester",
              "model": "LCR-P1",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_LCR-P1.jpg?v=1740568637",
              "url": "/products/lcr-p1",
              "status": "",
              "manuals": [
                {
                  "name": "LCR-P1 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-P1_Manual.pdf?v=1724379679",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "LCR-P1 Firmware V1.0.9.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-P1_Firmware_v1.0.9.zip?v=1748313678",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-P1 Firmware V1.0.8.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-P1_Firmware_v1.0.8.zip?v=1744257533",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-P1 Firmware V1.0.7.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-P1_Firmware_v1.0.7_New.zip?v=1740148930",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-P1 Firmware V1.0.6.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_LCR_P1_EN_V1.0.6_20241021.bin?v=1756274513",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-P1 Firmware V1.0.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_LCR_P1_EH_V1.0.5_240902.bin?v=1756274513",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-P1 Firmware V1.0.4.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/APP_LCR_P1_EH_V1.0.4_240820.bin?v=1756274513",
                  "btnText":"Download"
                }
              ],
              "updateTool": [
                {
                  "name": "LCR-P1 Upgrade Procedure.zip",
                  "url": "https://drive.google.com/file/d/1-4H33Aa8A1dAj2pKEnnmMrOPyPlc93nK/view?usp=sharing",
                  "btnText":"Download"
                }
              ],
              "updateTutorial": [
                {
                  "name": "Upgrade Video.mp4",
                  "url": "https://cdn.shopify.com/videos/c/o/v/8748ddb8b5e84cb384099b2bc38e747d.mp4",
                  "btnText":"Play Video"
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Tweezer LCR Meter",
          "categoryId": "tweezer-lcr-meter",
          "products": [
            {
              "productName": "FNIRSI® LC1020E High Precision Handheld Digital Bridge LCR ESR Tester",
              "model": "LC1020E",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_LC1020E.jpg?v=1754380740",
              "url": "/products/lc1020e",
              "status": "",
              "manuals": [
                {
                  "name": "LC1020E Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LC1020E_User_Manual.pdf?v=1754379738",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "LC1020E Firmware V1.1.zip (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LC1020E_V1.1_firmware.zip?v=1756204305",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® LCR-ST1 Mini Smart Digital Tweezer LCR SMD ESR Tester",
              "model": "LCR-ST1",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_LCR-ST1.jpg?v=1740568656",
              "url": "/products/lcr-st1",
              "status": "",
              "manuals": [
                {
                  "name": "LCR-ST1 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-ST1_User_Manual-2.pdf?v=1734746782",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "LCR-ST1 Firmware V1.6.bin (latest)",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-ST1-V1.6-20241121.bin?v=1756274821",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-ST1 Firmware V1.5.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-ST1-V1.5-20240827.bin?v=1756274820",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-ST1 Firmware V1.4.bin",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-ST1-V1.4-20240803.bin?v=1756274820",
                  "btnText":"Download"
                },
                {
                  "name": "LCR-ST1 Firmware V1.3.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/LCR-ST1_V1.3.zip?v=1756274819",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Imaging & Sensing",
      "categoryId": "imaging-sensing",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Imaging_Sensing.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Night Vision Device",
          "categoryId": "night-vision-device",
          "products": [
            {
              "productName": "FNIRSI® NVS-40 4K HD Binocular Night Vision Infrared 6x Digital Zoom",
              "model": "NVS-40",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_NVS-40.jpg?v=1740568727",
              "url": "/products/nvs-40",
              "status": "",
              "manuals": [
                {
                  "name": "NVS-40 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/New_NVS-40_User_Manual.pdf?v=1729927268",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            },
            {
              "productName": "FNIRSI® NVS-20 4K HD Monocular Night Vision Device Infrared 6x Digital Zoom",
              "model": "NVS-20",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_NVS-20.jpg?v=1740568722",
              "url": "/products/nvs-20",
              "status": "",
              "manuals": [
                {
                  "name": "NVS-20 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/NVS-20_Manual.pdf?v=1720662970",
                  "btnText":"Download"
                }
              ],
              "firmwares": [
                {
                  "name": "NVS-20 Firmware FW96675.zip",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/NVS-20_FW96675_f008829e-cdb0-4b50-9061-17c8de8d7c74.zip?v=1756205863",
                  "btnText":"Download"
                }
              ],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Automotive Tools",
      "categoryId": "automotive-tools",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Automotive_Tools.svg?v=1750762076",
      "subCategories": [
        {
          "categoryName": "Automotive Diagnostic Tool",
          "categoryId": "automotive-diagnostic-tool",
          "products": [
            {
              "productName": "FNIRSI® FD10 Car OBD2 Scanner Clear Error OBD Diagnostic Tool",
              "model": "FD10",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_FD10.jpg?v=1740568981",
              "url": "/products/fd10",
              "status": "",
              "manuals": [
                {
                  "name": "FD10 OBD Usage Steps (EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FD10_OBD_Usage_Steps.pdf?v=1738837052",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        },
        {
          "categoryName": "Coating Thickness Gauge",
          "categoryId": "coating-thickness-gauge",
          "products": [
            {
              "productName": "FNIRSI® CTG-20 Car Paint Coating Thickness Gauge",
              "model": "CTG-20",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_CTG-20.jpg?v=1740568962",
              "url": "/products/ctg-20",
              "status": "",
              "manuals": [
                {
                  "name": "CTG-20 Manual (ZH, EN).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/CTG-20_User_Manual_V-1.0.pdf?v=1732611387",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    },
    {
      "categoryName": "Other Devices",
      "categoryId": "other-devices",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Others.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Other Devices",
          "categoryId": "other-devices",
          "products": [
            {
              "productName": "FNIRSI® JBM-10 / JBM-20 Digital Brix Refractometer",
              "model": "JBM-10 / JBM-20",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_JBM-10_JBM-20.jpg?v=1740568807",
              "url": "/products/jbm-10-jbm-20",
              "status": "",
              "manuals": [
                {
                  "name": "JBM-10 / JBM-20 Manual (ZH, EN, RU, PT).pdf",
                  "url": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/JBM-10_JBM-20_Brix_Refractometer_Manual.pdf?v=1732869305",
                  "btnText":"Download"
                }
              ],
              "firmwares": [],
              "updateTool": [],
              "updateTutorial": []
            }
          ]
        }
      ]
    }
  ]
};